import React, { useState } from 'react';
import speechService from '../services/speechService';
import './VoiceInput.css';

function VoiceInput({ onTranscript }) {
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(null);

  const handleVoiceInput = () => {
    if (isListening) {
      speechService.stopListening();
      setIsListening(false);
      return;
    }

    setIsListening(true);
    setError(null);

    speechService.startListening(
      (transcript) => {
        setIsListening(false);
        onTranscript(transcript);
      },
      (err) => {
        setIsListening(false);
        setError(err);
        console.error('Speech recognition error:', err);
      }
    );
  };

  return (
    <div className="voice-input">
      <button
        onClick={handleVoiceInput}
        className={`voice-button ${isListening ? 'listening' : ''}`}
        disabled={!speechService.isAvailable()}
        title={speechService.isAvailable() ? 'Click to speak' : 'Speech recognition not available'}
      >
        {isListening ? '🎤 Listening...' : '🎤 Voice Input'}
      </button>
      {error && (
        <p className="error-message">Error: {error}</p>
      )}
      {!speechService.isAvailable() && (
        <p className="info-message">Voice input not supported in this browser</p>
      )}
    </div>
  );
}

export default VoiceInput;


